import { render, staticRenderFns } from "./PayPopup.vue?vue&type=template&id=2288dc24&scoped=true"
import script from "./PayPopup.vue?vue&type=script&lang=js"
export * from "./PayPopup.vue?vue&type=script&lang=js"
import style0 from "./PayPopup.vue?vue&type=style&index=0&id=2288dc24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2288dc24",
  null
  
)

export default component.exports